import { HTMLAttributes } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '../../../../common/button-new';
import { Modal } from '../../../../common';
import { ReferralModalRegistrationProps } from './referral-modal-login.models';
import { useStyles } from './referral-modal-login.styles';
import { cx } from '../../../../../utils';
import { StepsList } from '../steps-list';
import { v2026PP12192 } from '../../../../../constants/veeva';
import phone from '../../../../../assets/images/referral-modal/phone.svg';
import { ExternalLinks } from '../../../../../constants';

export const ReferralModalLogin = ({
  onClose, onAction, ...props
}: ReferralModalRegistrationProps): JSX.Element => {
  const classes = useStyles();

  const handleAction = async (): Promise<void> => {
    await onClose?.();
    onAction?.();
  };

  return (
    <Modal
      {...props}
      onClose={onClose}
      PaperProps={{
        'data-testid': 'referral-modal-login',
      } as HTMLAttributes<HTMLDivElement>}
      propsContentStyles={classes.content}
      propsPaperStyles={classes.paper}
      veevaNumber={v2026PP12192}
      isVeevaSmall
      content={(
        <>
          <h2 className={cx('title-medium', classes.title)} data-testid="referral-login-title">
            <FormattedMessage id="referral.modal.login.title" />
          </h2>
          <StepsList isRegistered={true} />
          <p className={classes.text}>
            <span><FormattedMessage id="referral.modal.login.text-1" /></span>
            <span><FormattedMessage id="referral.modal.login.text-2" /></span>
            <span className={classes.label}><FormattedMessage id="referral.modal.login.label" /></span>
          </p>
          <Button
            testId="download-app"
            to={ExternalLinks.mobileMarket}
            style="text"
            startIcon={<img src={phone} alt="" />}
            isExternalLink
            rootClasses={classes.download}
          >
            <FormattedMessage id="referral.modal.login.download" />
          </Button>
          <Button
            testId="start-fitting"
            onClick={handleAction}
            style="dark"
            rootClasses={classes.button}
          >
            <FormattedMessage id="referral.modal.login.button" />
          </Button>
        </>
      )}
    />
  );
};
